import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusExport.tsx
const IconApplicationStatusExport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M13.333 1.667 17.5 5.833v11.674c0 .456-.37.826-.828.826H3.328a.833.833 0 0 1-.828-.826V2.493c0-.456.37-.826.828-.826zM10.833 10h2.5L10 6.667 6.667 10h2.5v3.333h1.666z"
	})]
});
var IconApplicationStatusExport_default = forwardRef(IconApplicationStatusExport);
//#endregion
export { IconApplicationStatusExport_default as default };
